import { Card } from '@fl/cmsch-fe-library';
import React, { FC, memo, useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { AssociationType } from 'api/gen/AssociationType';
import { Content } from 'app/content';
import { useOurTranslation } from 'app/translations';
import { ConnectedScreenHeader } from 'common/layout';
import { matingAction } from '../../model';
import { BullSelectionTab } from '../bull-selection-tab';
interface Props {
  /** Title shown in the screen header and browser tab. */
  title: string;
  /** Association type that determines which bull catalog to load. */
  associationType: AssociationType;
}
const BullSelectorBase: FC<Props> = ({
  title,
  associationType
}) => {
  const {
    t
  } = useOurTranslation('mating');
  const dispatch = useDispatch();
  const resetScreen = useCallback(() => {
    dispatch(matingAction.resetScreen());
  }, [dispatch]);
  const initializeForms = useCallback(() => {
    dispatch(matingAction.initializeForms(true, associationType));
  }, [dispatch, associationType]);
  useEffect(() => {
    resetScreen();
  }, [resetScreen]);
  useEffect(() => {
    initializeForms();
  }, [initializeForms]);
  const header = useMemo(() => <ConnectedScreenHeader title={title} moduleForTutorials={associationType === 'HOLSTEIN' ? 'BULLSELECTOR_H' : 'BULLSELECTOR_C'} />, [associationType, title]);
  return <Content browserTabTitle={`${t(associationType === 'HOLSTEIN' ? 'bullSelectorH' : 'bullSelectorC')}`} noFooter data-sentry-element="Content" data-sentry-component="BullSelectorBase" data-sentry-source-file="index.tsx">
            <Card title={header} titleSize="medium" noWhiteSpaceBody data-sentry-element="Card" data-sentry-source-file="index.tsx">
                <BullSelectionTab associationType={associationType} loadingMsg={t('loadingBullSelector')} data-sentry-element="BullSelectionTab" data-sentry-source-file="index.tsx" />
            </Card>
        </Content>;
};

/**
 * Shared bull selector screen used by the Holstein and Fleckvieh routes.
 *
 * @param props Screen title and association type.
 * @returns The configured bull selector screen.
 *
 * @example
 * <BullSelector
 *   title="Bullselector - H"
 *   associationType="HOLSTEIN"
 * />
 */
export const BullSelector = memo(BullSelectorBase);